<script setup lang="ts">
    import { computed } from 'vue';
    import { BONUS_PROFESSIONS } from '~/types/professions';
    import { useUserDigest } from '~/composables/useUserDigest.client';

    const { auth } = useLoginState();
    const { digest } = useUserDigest();
    const { lang } = useLanguage();
    const { t } = useI18n();

    const isBonusEligible = computed(() => {
        if (!auth.value) return false;

        return Array.isArray(auth.value.groups)
            ? auth.value.groups.some((group) =>
                  BONUS_PROFESSIONS.includes(group.toUpperCase() as (typeof BONUS_PROFESSIONS)[number])
              )
            : false;
    });

    const showFallback = computed(() => {
        return digest.value !== undefined && !isBonusEligible.value;
    });
</script>

<template>
    <LoadingSpinner v-if="digest === undefined" />

    <BonusLightningOut
        v-else-if="digest && isBonusEligible"
        :digest="digest"
        :lang="lang"
    />

    <NuxtErrorBoundary v-else-if="showFallback">
        <template #error>
            <p class="bonus-fallback-error">{{ t('account.bonus.unavailable') }}</p>
        </template>

        <LazyBonusFallback />
    </NuxtErrorBoundary>
</template>
